import '../styles/app.scss';
import './app/main'

const loadedComponents = [];

document.addEventListener( 'DOMContentLoaded', async () => {
	/**
	 * Bootstrap the components
	 */
	for ( const dataComponent of document.querySelectorAll( '[data-component]' ) ) {
		let componentName = dataComponent.dataset.component;

		if ( loadedComponents.indexOf( componentName ) === - 1 ) {
			loadedComponents.push( componentName );

			try {
				await import(`./components/${componentName}.js`);
			} catch ( error ) {
				console.error( 'Loading error: ', error );
			}
		}
	}
} );
